// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"b532fe24","326":"3d533e3c","453":"5a8b46da","676":"ebc88ed7","986":"8f481064"}[chunkId] + ".chunk.js";
};